module.exports = __webpack_public_path__ + "static/img/icon_mail.0f68d5c7.svg";